import Modal from "components/Modal";
import styles from "components/modal/appInstallCouponModal.module.scss";
import TitleBar from "components/layout/TitleBar";
import classNames from "classnames";
import CouponDownloadIcon from "images/icons/coupon_download.svg";
import {customAlert} from "common/utils";
import {useRouter} from "next/router";
import {useState} from "react";
import {handleCouponDownload} from "components/modal/MainCouponModal";
import FullButton from "components/buttons/FullButton";
import {getHomeRoute, storeRoute} from "common/const";
import useTranslation from "next-translate/useTranslation";

const BokEventResult = (props) => {
    const {isWin, todayDayValue} = props;

    const [isLoading, setIsLoading] = useState(false);
    const {t} = useTranslation('components-modal-MainCouponModal');

    const router = useRouter();

    const coupon = {
        mold_key: `2402${todayDayValue < 10 ? `0${todayDayValue}` : todayDayValue}_bok_event_bonus_coupon`,
    };

    const onCouponDownloadSuccess = (couponIds) => {
        typeof mixpanel !== 'undefined' && mixpanel.track('BokEventCouponDownloadSuccess', {
            couponMoldKey: coupon.mold_key,
        });
        customAlert(
            `쿠폰을 다운로드 했어요!`,
            '확인',
            () => {
            }
        );
    }

    const handleClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('BokEventCouponDownloadClick', {
            couponMoldKey: coupon.mold_key,
        });

        handleCouponDownload(
            router,
            coupon,
            false,
            isLoading,
            setIsLoading,
            onCouponDownloadSuccess,
            t
        );
    };

    return (
        <div className={styles.resultContainer}>
            <div className={styles.resultTitle}>
                {isWin ? "복바구니 당첨 :D" : "다음 기회를 노려봅시다 :("}
            </div>
            <div className={styles.resultBodyText}>
                {
                    isWin ?
                        <>
                            축하드려요! 엄청난 행운의 소유자이시군요! <br/>
                            13일부터 순차 배송될 예정이니 조금만 기다려주세요
                        </> :
                        <>
                            복바구니 이벤트 참여하신 분들께만 시크릿 쿠폰 드려요! <br/>
                            담아 둔 제품 3시간 동안 최저가로 가져가세요 :)
                        </>
                }
            </div>
            {
                !isWin &&
                <div className={styles.couponCardContainer}>
                    <div className={classNames(styles.coupon)} onClick={handleClick}>
                        <div className={styles.couponInfo}>
                            <span className={styles.couponTitle}>12%</span>
                            <span className={styles.couponName}>아쉽지만 복바구니 놓칠 수 없지❤️</span>
                            <div className={styles.couponDescriptionContainer}>
                                <span className={styles.couponDescription}>쿠폰 사용기간: 오늘 자정까지</span>
                                <span className={styles.couponDescription}>최대할인금액: 10,000원</span>
                            </div>
                        </div>
                        <div className={styles.couponDownload}>
                            <CouponDownloadIcon/>
                        </div>
                    </div>
                    <div className={styles.footer}>
                        다운받은 쿠폰은 마이페이지 > 쿠폰함에서 확인할 수 있어요
                    </div>
                </div>
            }
        </div>
    )

};

const BokEventResultContentRow = (props) => {
    const {date, isParticipated, isWin, isWip} = props;

    return (
        <div className={styles.contentRow}>
            <div className={styles.rowDate}>{date}</div>
            <div
                className={classNames(styles.rowResult, isWip ? undefined : !isParticipated ? undefined : isWin ? styles.rowResultWin : styles.rowResultLose)}>{isWip ? "오늘 밤 9시 발표 예정" : !isParticipated ? "참여 이력이 없어요" : isWin ? "복바구니에 당첨되었어요!" : "아쉽게도 실패..."}</div>
        </div>
    )
};


const BokEventResultContent = (props) => {
    const {bokInfo, isWip} = props;

    const todayDate = bokInfo?.today_date_string ?? '02월 07일';

    return (
        <div className={styles.contentContainer}>
            <div className={styles.contentTitleContainer}>
                <span className={styles.contentTitle}>복바구니 당첨 내역</span>
            </div>
            <div className={styles.contentRowContainer}>
                {
                    Object.entries(bokInfo?.daily_result ?? {}).map(([date, countInfo]) => {
                        const isDateWip = date === todayDate && isWip;
                        const isWin = countInfo ? countInfo.win_count > 0 : false;
                        const isParticipated = countInfo ? countInfo.total_count > 0 : false;
                        return <BokEventResultContentRow
                            date={date.includes('10일') ? date.replace('0', '') : date.replaceAll('0', '')}
                            isWin={isWin}
                            isWip={isDateWip}
                            isParticipated={isParticipated}
                        />
                    })
                }
            </div>
        </div>
    )
}


const BokEventResultModal = (props) => {
    const {close, bokInfo} = props;
    const todayTimestamp = Date.now();

    const todayDate = bokInfo?.today_date_string ?? '02월 07일';
    const todayDayValue = parseInt(todayDate.split(' ')[1].split('일')[0]);
    const countInfo = bokInfo?.daily_result[todayDate] ?? null;
    const isWip = (bokInfo?.today_announce_at ?? 0) > todayTimestamp / 1000;
    const isParticipated = countInfo ? countInfo.total_count > 0 : false;
    const isWin = countInfo ? countInfo.win_count > 0 : false;

    const router = useRouter();

    const handleGoToShop = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('BokEventResultModalGoToShop');
        router.push(storeRoute);
    };

    const handleAcceptClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('BokEventResultModalAcceptClick');
        close();
    };

    const handleGoToHome = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('BokEventResultModalGoToHome');
        router.push(getHomeRoute());
    };

    return (
        <Modal width={'100%'} height={'100%'} isOpen={true}
               close={close}
        >
            <div className={styles.titleBar}>
                <TitleBar title="복바구니 응모 결과" close={close} isClose/>
            </div>
            {
                isParticipated && !isWip &&
                <BokEventResult isWin={isWin} todayDayValue={todayDayValue}/>
            }
            <div className={styles.body}>
                <BokEventResultContent bokInfo={bokInfo} isWip={isWip}/>
            </div>
            <div className={styles.bottomButtonContainer}>
                <div className={styles.button} onClick={isWin ? handleGoToHome : handleGoToShop}>
                    <FullButton title={isWin ? "홈으로 가기" : "쇼핑하러 가기"} height={48} fontSize={16} white/>
                </div>
                <div className={styles.button} onClick={handleAcceptClick}>
                    <FullButton title="확인" height={48} fontSize={16}/>
                </div>
            </div>
        </Modal>
    )
};

export default BokEventResultModal;
